import { withViewer } from '../../../external/common/hoc/with-viewer';
import AppRoot from '../../../external/post-list-widget/containers/app-root';

export default withViewer(AppRoot);
